import request from "../utils/request";

const activity = '/activity'

// 报名
export function application(data) {
    return request({
      url: activity + '/v3/operation-v2/user/log/add',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
    })
  }

//主活动配置
export function mainActivity(customId){
  return request({
    url:activity+`/v3/public/operation-v2/detail`,
    method:'get',
    data:{customId}
  })
}

//子活动配置
export function subActivity(operationId){
    return request({
      url:activity+`/v3/public/operation-v2/sub-detail `,
      method:'get',
      data:{operationId}
    })
  }


//查看用户是否已经报名
export function findUserOperation(data) {
    return request({
      url: activity + '/v3/operation-v2/user/log/query',
      method: 'get',
      data
    })
  }


// WEBPACK FOOTER //
// ./src/api/hotCoin.js